<template>
  <button class="button" :disabled="disabled" @click="onClick || undefined">
    <i class="material-icons">keyboard_arrow_right</i>
  </button>
</template>

<script lang="babel">
export default {
  name: 'FloatingButton',
  props: {
    type: {
      type: String,
      required: false,
      default: 'button'
    },
    disabled: {
      type: Boolean,
      required: false,
      default: true
    },
    onClick: {
      type: Function,
      required: false
    }
  }
}
</script>

<style lang="scss" scoped>
.button {
  z-index: 1000;

  display: block;
  width: 56px;
  height: 56px;
  border: none;
  border-radius: 50%;
  position: fixed;
  bottom: 24px;
  right: 16px;
  color: white;
  background-color: #F94848;
  box-shadow: 0 5px 12px rgba(111, 0, 24, 0.2);
  text-align: center;

  .material-icons {
    font-size: 30px;
    line-height: 56px;
  }

  &:disabled {
    background: #E0E0E0;
  }
}
</style>
